export default ({request}) => ({
  changeOrderTechDocListApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDoc/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDoc/specList',
      method: 'post',
      data,
    })
  },
  changeOrderTechDocDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDoc/detail',
      method: 'post',
      data,
    })
  },
  changeOrderTechDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDoc/batchUpload',
      method: 'post',
      data,
    })
  },
  changeOrderTechDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDoc/batchDel',
      method: 'post',
      data,
    })
  },
  changeOrderTechDocUpdateApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDoc/update',
      method: 'post',
      data,
    })
  },
  changeOrderTechDocSpecListApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDocSpec/list',
      method: 'post',
      data,
    })
  },
  changeOrderTechDocSpecBatchDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDocSpec/batchDel',
      method: 'post',
      data,
    })
  },
  changeOrderTechDocSpecBatchAddApi(data = {}) {
    return request({
      url: '/factory/changeOrderTechDocSpec/batchAdd',
      method: 'post',
      data,
    })
  },
})
